/* ==========================================================================
   Section: Peek Inside (page flip)

   The only behaviour here that isn't already covered by lightkeepers-motion.js
   (reveals, parallax) or lk-shop.js (add to cart): cycling interior art
   through a hinged page that flips on its spine. Everything else in this
   section — layout, the static first spread — needs no JavaScript at all.

   Images come from data-lk-flip-images, a JSON array the section writes from
   its blocks or from live product media, so the art can be swapped without
   touching code.

   ACCESSIBILITY
   The flip starts on its own and repeats indefinitely, so WCAG 2.2.2 requires
   a way to stop it. The pause button is rendered hidden by the section and
   revealed here, so it only ever appears when it can actually do something.
   Under prefers-reduced-motion nothing animates and the button stays hidden —
   there is no motion to pause.
   ========================================================================== */

(function () {
  'use strict';

  function initFlip(root) {
    if (root.dataset.lkFlipBound === 'true') return;

    var box = root.querySelector('[data-lk-flip-box]');
    var left = root.querySelector('[data-lk-flip-left]');
    var base = root.querySelector('[data-lk-flip-base]');
    var front = root.querySelector('[data-lk-flip-front]');
    var back = root.querySelector('[data-lk-flip-back]');
    var toggle = root.querySelector('[data-lk-flip-toggle]');
    if (!box || !left || !base || !front || !back) return;

    root.dataset.lkFlipBound = 'true';

    var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduceQuery.matches || root.dataset.lkFlipAuto === 'false') return;

    var images = [];
    try {
      images = JSON.parse(root.dataset.lkFlipImages || '[]');
    } catch (e) {
      images = [];
    }
    if (images.length < 3) return;

    /* Alt text, one entry per image. The flip swaps src; alt has to move with
       it or a screen reader keeps announcing the previous picture. */
    var alts = [];
    try {
      alts = JSON.parse(root.dataset.lkFlipAlts || '[]');
    } catch (e) {
      alts = [];
    }
    function altFor(i) {
      var a = alts[i];
      return typeof a === 'string' ? a : '';
    }

    var interval = parseInt(root.dataset.lkFlipInterval, 10) || 3800;
    var idx = 0;
    var flipping = false;
    var visible = false;
    var paused = false; // set by the visitor, and only by the visitor
    var timer = null;

    function doFlip() {
      if (paused || flipping || document.hidden || !visible) return;
      flipping = true;
      var cur = idx % images.length;
      var next = (idx + 1) % images.length;
      var after = (idx + 2) % images.length;

      box.style.transition = 'transform 1.4s cubic-bezier(.45,.05,.25,1)';
      box.style.transform = 'rotateY(-180deg)';

      function done() {
        box.removeEventListener('transitionend', done);
        left.src = images[cur];
        left.alt = altFor(cur);
        box.style.transition = 'none';
        box.style.transform = 'rotateY(0deg)';
        front.src = images[next];
        back.src = images[next];
        base.src = images[after];
        base.alt = altFor(after);
        /* front and back are the moving page itself, marked aria-hidden by the
           section, so they stay alt="" on purpose. */
        idx += 1;
        flipping = false;
      }
      box.addEventListener('transitionend', done);
    }

    var io = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
    }, { threshold: 0.2 });
    io.observe(root);

    timer = window.setInterval(doFlip, interval);

    /* --- Pause control --------------------------------------------------- */
    if (toggle) {
      toggle.hidden = false; // only now is it a control that does something

      toggle.addEventListener('click', function () {
        paused = !paused;
        toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        toggle.textContent = paused
          ? toggle.dataset.lkPlayLabel || 'Resume page turning'
          : toggle.dataset.lkPauseLabel || 'Pause page turning';
      });
    }

    root.__lkFlipCleanup = function () {
      io.disconnect();
      window.clearInterval(timer);
    };
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-lk-page-flip]').forEach(initFlip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-lk-page-flip]');
    if (root && root.__lkFlipCleanup) root.__lkFlipCleanup();
  });
})();
